/**
 * Normalizes Arabic text for searching and comparison by standardizing common characters.
 * @param text The input Arabic string
 * @returns A normalized version of the string
 */
export const normalizeArabic = (text: string): string =>
  text
    .replace(/[أإآ]/g, 'ا')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي')
    .replace(/ؤ/g, 'و')
    .replace(/ئ/g, 'ي')
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .trim();
